import { Controller } from '@hotwired/stimulus'

// Connects data-controller="admin-event-comparison"
export default class extends Controller {
  static values = {
    key: String
  }

  static targets = ['checkbox']

  connect () {
    this.clearEventIdsOnReload()
    this.loadEventIds()
  }

  clearEventIdsOnReload () {
    window.addEventListener('beforeunload', () => {
      const navigationEntries = performance.getEntriesByType('navigation')
      if (navigationEntries[0].type === 'reload') {
        sessionStorage.removeItem(this.keyValue)
      }
    })
  }

  loadEventIds () {
    const storedIds = this.getStoredEventIds()

    this.checkboxTargets.forEach(checkbox => {
      if (storedIds.includes(checkbox.value)) {
        checkbox.checked = true
      }
    })
  }

  storeEventId (event) {
    const checkbox = event.target

    let storedIds = this.getStoredEventIds()

    if (checkbox.checked) {
      if (!storedIds.includes(checkbox.value)) {
        storedIds.push(checkbox.value)
      }
    } else {
      storedIds = storedIds.filter(id => id !== checkbox.value)
    }
    sessionStorage.setItem(this.keyValue, JSON.stringify(storedIds))
  }

  view (event) {
    const target = event.target

    if (target.closest('a, button, input, select, textarea, [role="button"], .adminEvents-companyColumn') !== null) return

    window.location.assign(event.currentTarget.dataset.eventUrl)
  }

  getStoredEventIds () {
    const storedValue = sessionStorage.getItem(this.keyValue)
    return (storedValue !== null) ? JSON.parse(storedValue) : []
  }

  submit (event) {
    event.preventDefault()
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
    const storedIds = this.getStoredEventIds()
    const url = `/admin/events/comparison?event_ids[]=${storedIds.join('&event_ids[]=')}`
    window.location.href = url
    sessionStorage.removeItem(this.keyValue)
  }
}
